import type { TAnalyticsSearchOutput } from './getAnalyticsSearchOutput';

export type TGetCommonMplAnalyticsParamsArgs = {
  category: number;
  subCategory: number;
  scenario: string;
  scenarioCalcId: string | undefined;
  rankingCalcId: string | undefined;
  filter: string;
  searchOutput: TAnalyticsSearchOutput;
};

export type TCommonMplAnalyticsParams = {
  category: number;
  subCategory: number;
  scenario: string;
  calcId: string | null;
  filter: string;
  searchOutput: TAnalyticsSearchOutput;
};

export const getCommonMplAnalyticsParams = ({
  category,
  subCategory,
  scenario,
  scenarioCalcId,
  rankingCalcId,
  filter,
  searchOutput,
}: TGetCommonMplAnalyticsParamsArgs): TCommonMplAnalyticsParams => ({
  category,
  subCategory,
  scenario,
  calcId: scenarioCalcId || rankingCalcId || null,
  filter,
  searchOutput,
});
